import { MarketSortOption } from '@/constants/sort';
import { ReqGetSpecialProducts } from '@/service/market/special/getSpecialProducts';

export const RQSpecialKey = {
  specialHomeProducts: ['main', 'special'] as const,
  specialPageProducts: (
    query: ReqGetSpecialProducts['query'],
    sortOption: MarketSortOption | null
  ) => ['special', query, sortOption] as const,
};
